import * as React from 'react'

import { cn } from '@/lib/utils'

import { Label } from './label'

interface InputProps extends React.ComponentProps<'input'> {
  label?: string
  labelClassName?: string
  labelProps?: React.ComponentProps<'label'>
  helperText?: string
  containerClassName?: string
  trailingIcon?: React.ReactNode
  error?: boolean
}
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, label, labelClassName, labelProps, helperText, containerClassName, trailingIcon, error = false, ...props }, ref) => {
    const { className: labelClassNameProps, ...restLabelProps } = labelProps || {}
    return (
      <div className={cn('relative flex flex-col', containerClassName)}>
        {label && (
          <Label className={cn('text-text-primary text-sm', labelClassName || labelClassNameProps)} htmlFor={props.id} {...restLabelProps}>
            {label}
          </Label>
        )}
        <input
          ref={ref}
          type={type}
          data-slot='input'
          className={cn(
            'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input h-9 w-full min-w-0 rounded-md border bg-white px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:cursor-not-allowed disabled:bg-[#e9ecef] md:text-sm',
            'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
            'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
            className,
            error && 'border-destructive'
          )}
          {...props}
        />
        {helperText && <small className={cn('text-muted-foreground text-sm', error && 'text-destructive')}>{helperText}</small>}
        {trailingIcon && <div className='absolute end-2 bottom-[18px] translate-y-1/2'>{trailingIcon}</div>}
      </div>
    )
  }
)

export { Input }
